import { cartLinkStyles as styles } from "@insite/content-library/Widgets/Common/CartLink";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

styles.routerLink = {
    ...styles.routerLink,
    css: css`
        display: flex;
        height: 100%;

        &:hover {
            color: ${getColor(colorStrings.commonGlobalWhite)};

            svg,
            &&&& ${TypographyStyle} {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        }
    `,
};
